export const EMPTY_OBJECT = {};
export const EMPTY_FUNCTION = () => undefined;
export const EMPTY_ARRAY = [];
